import { render, staticRenderFns } from "./video-player.vue?vue&type=template&id=3cd49471&scoped=true&"
import script from "./video-player.vue?vue&type=script&lang=js&"
export * from "./video-player.vue?vue&type=script&lang=js&"
import style0 from "./video-player.vue?vue&type=style&index=0&id=3cd49471&prod&lang=css&"
import style1 from "./video-player.vue?vue&type=style&index=1&id=3cd49471&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd49471",
  null
  
)

export default component.exports